<template>
    <v-layout row wrap>
        <v-flex xs12 class="subheading mb-1 grey--text text--darken-2">
            {{ formattedLabel(
                metadata[`description${this.upperLocale}`],
                required
            ) }}
        </v-flex>
        <v-flex xs12>
            <v-select
                class="body-2 tz-dropdown"
                :value="value"
                :name="metadata.name"
                item-text="text"
                item-value="value"
                :label="!required ? dropBoxOptions[2].text : $t('base.choice')"
                :outlined="outlined"
                :append-icon="appendIcon"
                :items="dropBoxOptions"
                :color="$vuetify.theme.primary"
                :background-color="$vuetify.theme.primary"
                :placeholder="placeholder"
                single-line
                flat
                dense
                :rules="[
                    !required || requiredField()
                ]"
                :data-meta-id="metadata.id"
                :id="metadata.name"
                @input="emitValue"
            />
        </v-flex>
    </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import { inputHelpers } from '@/mixins/inputHelpers';

export default {
    name: 'vaccine-security-acceptance',
    mixins: [formRules, inputHelpers],
    props: {
        metadata: { type: Object, required: true },
        outlined: { type: Boolean, required: false, default: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: String, required: false, default: null },
        withIcon: { type: Boolean, required: false, default: false },
        placeholder: { type: String, required: false, default: '' },
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),
        appendIcon() {
            return this.withIcon ? 'fas fa-vote-yea' : '';
        },
        dropBoxOptions() {
            let choice = [
                { key: 0, text: this.$i18n.t('base.yes'), value: 'yes' },
                { key: 1, text: this.$i18n.t('base.no'), value: 'no' },
            ];
            if (!this.required) {
                choice.push({ key: 2, text: this.$i18n.t('base.noAnswer'), value: null });
            }
            return choice;
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>
